import { render, staticRenderFns } from "./ExpandableNavigationDrawer.vue?vue&type=template&id=20f8a8fd&scoped=true"
import script from "./ExpandableNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./ExpandableNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./ExpandableNavigationDrawer.vue?vue&type=style&index=0&id=20f8a8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8a8fd",
  null
  
)

export default component.exports